import { View, Text, Image, Keyboard, TouchableOpacity, TextInput, ScrollView } from "react-native";
import React, { useEffect, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import {
  StackActions,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../Utility/AppScreens";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import CommonTextInputWeb from "../../../common/CommonTextInputWeb";
import { base_url, endpoints, urls } from "../../../Api/configs";
import { ShowLoader } from "../../../common/ShowLoader";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getLoginData, storeLoginData } from "../../../utility/AppStoreData";
import { login } from "../../../services/authAPI";
import { toast } from "react-toastify";
import { getUserLocationDetails } from "../../../common/getLocation";
import { dynamicWebUrl } from "../../../Api/configs";
import { ScreenBGGradientView } from "../../../common/CommonView";
import { useAuthProvider } from "../../../context/AuthContext";

// Country codes list
const countryCodes = [
  { code: '+1', country: 'US/CA' },
  { code: '+44', country: 'UK' },
  { code: '+91', country: 'IN' },
  { code: '+61', country: 'AU' },
  { code: '+86', country: 'CN' },
  { code: '+81', country: 'JP' },
  { code: '+49', country: 'DE' },
  { code: '+33', country: 'FR' },
  { code: '+39', country: 'IT' },
  { code: '+34', country: 'ES' },
  { code: '+7', country: 'RU' },
  { code: '+55', country: 'BR' },
  { code: '+52', country: 'MX' },
  { code: '+82', country: 'KR' },
  { code: '+65', country: 'SG' },
  { code: '+971', country: 'AE' },
  { code: '+966', country: 'SA' },
  { code: '+27', country: 'ZA' },
  { code: '+234', country: 'NG' },
  { code: '+254', country: 'KE' },
];

const LoginWebScreen = ({ route }) => {
  const { path = "" } = route.params || {};

  const navigation = useNavigation();
  const { refreshLoginState } = useAuthProvider();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const isMobile =
    deviceSize === DEVICE_SIZES.XS ||
    deviceSize === DEVICE_SIZES.SM ||
    deviceSize === DEVICE_SIZES.MD ||
    deviceSize === DEVICE_SIZES.LG;
  const [showPassword, setShowPassword] = useState(false);
  const [showSignUpScreenModal, setShowSignUpScreenModal] = useState(false);
  // Auth type toggle: 'email' (default) or 'phone'
  const [authType, setAuthType] = useState<'email' | 'phone'>('email');
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");

  useEffect(() => {
    // navigation.addListener("beforeRemove", (e) => {
    //     // Confirm with user, perform actions before back navigation

    //     if (confirm("Leave this page?")) {
    //         e.preventDefault();
    //         // Replace navigation with other logic if not back
    //     }
    // });

    const handleBackButton = (event) => {
      // Perform actions or prevent default behavior

      const fetchLoginData = async () => {
        try {
          const data = await getLoginData();
          if (data != null) {
            if (path) {
              window.location.href = `${dynamicWebUrl}${path}`;
            } else {
              navigateToScreen(navigation, AppScreens.DrawerRoute, {
                username: username,
              });
            }
          }
        } catch (error) {
          console.error("Error fetching login data: ", error);
        }
      };

      fetchLoginData();
      // Handle the back button action here, such as navigating
      // history.push('/some-other-route'); // Navigate to another route using history

      // Return false to indicate that the back press is handled
      return false; // Change this as needed
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };

    // const handleBackButton = (event) => {
    //     // Perform actions or prevent default behavior
    //     // For example:
    //     // Show a message or perform a specific action
    //     // Return false to indicate that the back press is handled
    //     return false; // Change this as needed
    // };
    // window.addEventListener('popstate', handleBackButton);
    // return () => {
    //     window.removeEventListener('popstate', handleBackButton);
    // };
  }, []);
  useEffect(() => {
    const fetchLoginData = async () => {
      try {
        const data = await getLoginData();
        if (data != null) {
          if (path) {
            window.location.href = `${dynamicWebUrl}${path}`;
          } else {
            navigateToScreen(navigation, AppScreens.DrawerRoute, {
              username: username,
            });
          }
        } else {
          // Check if we should show logout/session expired toast
          const showLogoutSuccess = sessionStorage.getItem(
            "showLogoutSuccessToast"
          );
          const showLogoutError = sessionStorage.getItem(
            "showLogoutErrorToast"
          );
          const showSessionExpired = sessionStorage.getItem(
            "showSessionExpiredToast"
          );

          if (showLogoutSuccess === "true") {
            sessionStorage.removeItem("showLogoutSuccessToast");
            setTimeout(() => {
              toast.success("Logged out successfully");
            }, 100);
          } else if (showLogoutError === "true") {
            sessionStorage.removeItem("showLogoutErrorToast");
            setTimeout(() => {
              toast.error("Logout error, but you've been logged out locally");
            }, 100);
          } else if (showSessionExpired === "true") {
            sessionStorage.removeItem("showSessionExpiredToast");
            setTimeout(() => {
              toast.info("Session expired. Please login again.");
            }, 100);
          }
        }
      } catch (error) {
        console.error("Error fetching login data: ", error);
      }
    };

    fetchLoginData();
  }, []);

  const handleLogin = async () => {
    if (checkValidation()) {
      try {
        const params = authType === 'phone'
          ? {
            username: `${countryCode}${phoneNumber}`,
            password: password,
            authType: 'phone',
          }
          : {
            username: username,
            password: password,
            authType: 'email',
          };

        setShowLoader(true);

        const data = await login(params);

        console.log("Login response data:", data);

        if (data.status === 200) {
          toast.success("Login sucessfull");
          clearData();

          // Store new login data
          storeLoginData(data.body);
          await AsyncStorage.setItem("username", username);
          await getUserLocationDetails();

          // Check for post-login redirect URL from unified signup/login flow context
          let postLoginRedirect = null;

          // Priority 1: Check loginFlowContext (when user clicks "Login" from GameShowPreviewScreen)
          const loginFlowContextStr =
            sessionStorage.getItem("loginFlowContext");
          if (loginFlowContextStr) {
            try {
              const loginFlowContext = JSON.parse(loginFlowContextStr);
              postLoginRedirect = loginFlowContext.postLoginRedirectURL;
              console.log(
                "💾 LoginWebScreen: Found postLoginRedirectURL in loginFlowContext:",
                postLoginRedirect
              );
            } catch (error) {
              console.warn(
                "⚠️ LoginWebScreen: Error parsing loginFlowContext:",
                error
              );
            }
          }

          // Priority 2: Check signupFlowContext (when user signs up from GameShowPreviewScreen but then logs in)
          if (!postLoginRedirect) {
            const signupFlowContextStr =
              sessionStorage.getItem("signupFlowContext");
            if (signupFlowContextStr) {
              try {
                const signupFlowContext = JSON.parse(signupFlowContextStr);
                postLoginRedirect = signupFlowContext.postLoginRedirectURL;
                console.log(
                  "💾 LoginWebScreen: Found postLoginRedirectURL in signupFlowContext:",
                  postLoginRedirect
                );
              } catch (error) {
                console.warn(
                  "⚠️ LoginWebScreen: Error parsing signupFlowContext:",
                  error
                );
              }
            }
          }

          // Priority 3: Check legacy standalone postLoginRedirect
          if (!postLoginRedirect) {
            postLoginRedirect = sessionStorage.getItem("postLoginRedirect");
            if (postLoginRedirect) {
              console.log(
                "💾 LoginWebScreen: Found legacy postLoginRedirect:",
                postLoginRedirect
              );
            }
          }

          if (postLoginRedirect) {
            console.log(
              "🔄 LoginWebScreen: Successfully logged in, removing signupFlowContext after API success"
            );

            // Remove signupFlowContext after successful login (keep loginFlowContext for now)
            sessionStorage.removeItem("postLoginRedirect");
            sessionStorage.removeItem("signupFlowContext");

            // Clear GameShow session data since user is now authenticated
            const { clearGameShowSessionData } = await import(
              "../../../utility/gameShowUrlUtils"
            );
            clearGameShowSessionData();

            console.log(
              "🔄 LoginWebScreen: Redirecting to:",
              postLoginRedirect
            );
            window.location.href = postLoginRedirect;
            return;
          }

          // For specific path redirects, use window.location
          if (path) {
            window.location.href = `${dynamicWebUrl}${path}`;
            return;
          }

          // Redirect to home page - this will cause one smooth reload
          // AuthContext will detect the login and load everything properly
          window.location.href = window.location.origin;
        }
        if (data.status === 400) {
          const errorMessage = data?.body;
          // Check if error is related to email verification pending
          if (
            errorMessage?.error &&
            errorMessage.error.includes("Email verification pending")
          ) {
            toast.info("Please verify your email to continue");

            // Store username and password in cookie for auto-login after verification
            document.cookie = `password=${password}; path=/; max-age=86400;`;

            // Store username in sessionStorage for email confirmation screen
            sessionStorage.setItem("pendingLoginUsername", username);

            // Navigate to email confirmation screen
            navigateToScreen(
              navigation,
              AppScreens.EmailConfirmationWebScreen,
              {
                username: username,
                fromLogin: true, // Flag to indicate this is from login flow
              }
            );
          } else {
            toast.error(errorMessage?.error || "Login failed");
          }
        }
        if (data.status === 401) {
          const errorMessage = data?.body;
          toast.error(errorMessage.error);
        }
      } catch (error) {
        toast.error(error.error);
      } finally {
        setShowLoader(false);
      }
    }
  };

  return (
    <View style={styles.container}>
      <ScreenBGGradientView />
      <View
        style={{
          // flex: 0.7,
          // flex: 1,

          ...(isMobile
            ? { flex: 1 }
            : { flex: 0.4 }),
        }}
      >
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: isMobile ? "flex-start" : "center",
            paddingBottom: 0,
          }}
          showsVerticalScrollIndicator={false}
          keyboardShouldPersistTaps="handled"
        >
          {deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG ? (
            <View style={{ alignItems: "center", marginTop: 10 }}>
              <View
                style={{
                  borderRadius: 12,
                  width: "90%",
                  maxWidth: 380,
                  height: 260,
                  elevation: 20,
                }}
              >
                <Image
                  source={AppImages.icMainLogo}
                  style={{
                    resizeMode: "contain",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </View>
            </View>
          ) : null}
          <>
            {" "}
            <View
              style={{
                paddingLeft:
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.MD ||
                    deviceSize === DEVICE_SIZES.LG
                    ? "5%"
                    : "15%",
                paddingRight:
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.MD ||
                    deviceSize === DEVICE_SIZES.LG
                    ? "5%"
                    : 0,
              }}
            >
              {/* Login */}
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.BOLD_ANYBODY_25
                    : AppFontStyle.BOLD_ANYBODY_32,
                  {
                    color: AppColors.white,
                    marginVertical: 15,
                    ...(deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.MD ||
                      deviceSize === DEVICE_SIZES.LG
                      ? { marginTop: 30 }
                      : {}),
                  },
                ]}
              >
                Login
              </Text>

              {/* Auth Type Toggle */}
              <TouchableOpacity
                style={{ alignSelf: 'flex-end', marginBottom: 10, flexDirection: 'row', alignItems: 'center' }}
                onPress={() => setAuthType(authType === 'phone' ? 'email' : 'phone')}
              >
                {authType === 'phone' ? (
                  <Image
                    source={require('../../../../assets/auth/use-email-register.svg')}
                    style={{ width: 18, height: 18, marginRight: 6 }}
                    resizeMode="contain"
                  />
                ) : (
                  <Text style={{ marginRight: 6, fontSize: 16 }}>📱</Text>
                )}
                <Text style={{ color: '#DC2626', fontSize: 14, fontWeight: '800', lineHeight: 24 }}>
                  {authType === 'phone' ? 'Use Email/Username' : 'Use Mobile'}
                </Text>
              </TouchableOpacity>

              {/* Conditional: Phone Number or Email/Username Input */}
              {authType === 'phone' ? (
                <View style={{
                  flexDirection: 'row',
                  marginBottom: 10,
                  borderRadius: 8,
                  backgroundColor: AppColors.appGrayColor_1C1C1C,
                  overflow: 'hidden',
                  height: 48,
                  position: 'relative',
                }}>
                  {/* Country Code Dropdown */}
                  <View style={{
                    justifyContent: 'center',
                    borderRightWidth: 1,
                    borderRightColor: '#374151',
                    paddingHorizontal: 4,
                  }}>
                    <select
                      style={{
                        height: '100%',
                        paddingLeft: 8,
                        paddingRight: 4,
                        background: '#1F2937',
                        border: 'none',
                        color: '#FFFFFF',
                        fontSize: 12,
                        fontFamily: 'Anybody_400Regular',
                        outline: 'none',
                        cursor: 'pointer',
                      }}
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                    >
                      {countryCodes.map((item, index) => (
                        <option key={index} value={item.code} style={{ backgroundColor: '#1F2937', color: '#FFFFFF' }}>
                          {item.code} {item.country}
                        </option>
                      ))}
                    </select>
                  </View>
                  {/* Phone Input */}
                  <TextInput
                    style={{
                      flex: 1,
                      paddingHorizontal: 12,
                      paddingRight: 30,
                      color: AppColors.white,
                      fontSize: 12,
                      fontFamily: 'Anybody_400Regular',
                    }}
                    placeholder="Phone Number"
                    placeholderTextColor={AppColors.white}
                    value={phoneNumber}
                    onChangeText={(text) => setPhoneNumber(text.replace(/[^0-9]/g, ''))}
                    keyboardType="phone-pad"
                    maxLength={15}
                    onSubmitEditing={() => {
                      Keyboard.dismiss();
                      handleLogin();
                    }}
                  />
                  {/* Asterisk indicator */}
                  <View style={{
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    justifyContent: 'center',
                    paddingTop: 5,
                    paddingRight: 10,
                  }}>
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_30, { color: AppColors.white }]}>*</Text>
                  </View>
                </View>
              ) : (
                <CommonTextInputWeb
                  placeholder="Email or Username"
                  mainStyle={[styles.inputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                  prefixIconVisibility={false}
                  onChangeText={setUsername}
                  isPassword={false}
                  value={username}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                    handleLogin();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                  isRequired={true}
                />
              )}

              {/* Password */}
              <CommonTextInputWeb
                placeholder="Password"
                mainStyle={[styles.inputStyle]}
                inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                prefixIconVisibility={false}
                onChangeText={setPassword}
                isPassword={true}
                value={password}
                secureTextEntry={showPassword ? false : true}
                onSubmitEditing={() => {
                  Keyboard.dismiss();
                  handleLogin();
                }}
                autoCapitalize="none"
                maxLength={50}
                isRequired={true}
                onPressEyeIcon={() => {
                  setShowPassword(!showPassword);
                }}
                rightIcon={showPassword ? AppImages.icEye : AppImages.icEyeClose}
                showEyeIcon={true}
                rightIconStyle={{ width: 20, height: 20 }}
              />

              <View
                style={{
                  height: 20,
                  marginVertical: 10,
                  alignItems: "flex-end",
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    navigateToScreen(
                      navigation,
                      AppScreens.ResetPasswordWebScreen
                    );
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_14,
                      { color: AppColors.white },
                    ]}
                  >
                    Forgot Password?
                  </Text>
                </TouchableOpacity>
              </View>

              {/* Login Button */}
              <TouchableOpacity
                style={styles.btnLoginStyle}
                onPress={handleLogin}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_14,
                    { color: AppColors.white },
                  ]}
                >
                  Login
                </Text>
              </TouchableOpacity>

              {/* Don't have an Account? Signup */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  marginVertical: 20,
                  // flex: 1,
                }}
              >
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    {
                      color: "white",
                    },
                  ]}
                >
                  Don't have an Account?
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const loginFlowContextStr =
                      sessionStorage.getItem("loginFlowContext");
                    if (loginFlowContextStr) {
                      try {
                        const loginFlowContext = JSON.parse(loginFlowContextStr);
                        const signupFlowContext = {
                          flowType: loginFlowContext.flowType,
                          referralCode: loginFlowContext.referralCode || "",
                          directReferrerId:
                            loginFlowContext.directReferrerId || "",
                          postSignupRedirectURL:
                            loginFlowContext.postLoginRedirectURL || "",
                          suppressClaimCoinsPopup:
                            loginFlowContext.suppressClaimCoinsPopup,
                          timestamp: Date.now(),
                        };
                        sessionStorage.setItem(
                          "signupFlowContext",
                          JSON.stringify(signupFlowContext)
                        );
                        console.log(
                          "💾 LoginWebScreen: Created signupFlowContext from loginFlowContext:",
                          signupFlowContext
                        );
                        console.log(
                          "💾 LoginWebScreen: Keeping both contexts alive until API call succeeds"
                        );
                      } catch (error) {
                        console.warn(
                          "Error converting login to signup context:",
                          error
                        );
                      }
                    }
                    navigateToScreen(navigation, AppScreens.SignupWebScreen);
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_14,
                      {
                        color: "white",
                      },
                    ]}
                  >
                    {" "}
                    Register{" "}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>



            {isMobile && (
              <View
                style={{
                  marginTop: "auto",
                  alignSelf: "flex-end",
                  marginBottom: 20,
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: "5%",
                }}
              >
                <Image
                  source={AppImages.icYoutubeLogo}
                  style={{
                    width: 56,
                    height: 56,
                    marginRight: 8,
                  }}
                  resizeMode="contain"
                />
                <Image
                  source={AppImages.icTwitchLogo}
                  style={{
                    width: 56,
                    height: 56,
                  }}
                  resizeMode="contain"
                />
              </View>
            )}
          </>
        </ScrollView>
      </View>
      {
        deviceSize !== DEVICE_SIZES.XS &&
          deviceSize !== DEVICE_SIZES.SM &&
          deviceSize !== DEVICE_SIZES.MD &&
          deviceSize !== DEVICE_SIZES.LG ? (
          <View
            style={[
              styles.leftWrapper,
              {
                position: "relative",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: "5%",
              },
            ]}
          >
            <View
              style={{
                borderRadius: 12,
                elevation: 20,
              }}
            >
              <Image
                source={AppImages.icMainLogo}
                style={{
                  width: 764,
                  height: 468,
                }}
                resizeMode="contain"
              />
            </View>
          </View>
        ) : null
      }
      {!isMobile && (
        <View
          style={{
            flexDirection: "row",
            position: "absolute",
            bottom: 20,
            right: 30,
            alignItems: "center",
          }}
        >
          <Image
            source={AppImages.icYoutubeLogo}
            style={{
              width: 56,
              height: 56,
              marginRight: 8,
            }}
            resizeMode="contain"
          />
          <Image
            source={AppImages.icTwitchLogo}
            style={{
              width: 56,
              height: 56,
            }}
            resizeMode="contain"
          />
        </View>
      )}

      {<ShowLoader showIndicater={showLoader} isBackGround={true} />}
    </View>
  );


  function clearData() {
    setUsername("");
    setPassword("");
  }

  function checkValidation() {
    if (authType === 'phone') {
      const digitsOnly = phoneNumber.replace(/\D/g, '');
      if (phoneNumber === "") {
        toast.error("Enter Phone Number");
        return false;
      }
      if (digitsOnly.length < 7) {
        toast.error("Phone number is too short. Please enter a valid phone number.");
        return false;
      }
      if (digitsOnly.length > 10) {
        toast.error("Phone number is too long. Please enter up to 10 digits (without country code).");
        return false;
      }
    } else {
      if (username === "") {
        toast.error("Enter Email or Username");
        return false;
      }
    }
    if (password === "") {
      toast.error("Enter Password");
      return false;
    }
    return true;
  }
};

export default LoginWebScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 30,
    },
    shodowTop: {
      height: "100%",
      width: "100%",
      position: "absolute",
      resizeMode: "stretch",
    },
    inputStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      marginBottom: 10,
    },
    btnLoginStyle: {
      height: 40,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: AppColors.buttonRed_DC2626,
      marginHorizontal: "20%",
      borderRadius: 20,
    },
    leftWrapper: {
      flex: 0.6,
      alignItems: "flex-end",
      justifyContent: "space-between",
    },
    shodowBottom: {
      height: "50%",
      width: "68%",
      position: "absolute",
      resizeMode: "stretch",
      bottom: 0,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      shodowBottom: {
        height: "30%",
      },
    },
    [DEVICE_SIZES.SM]: {
      shodowBottom: {
        height: "30%",
      },
    },
    [DEVICE_SIZES.XS]: {
      shodowBottom: {
        height: "30%",
      },
    },
  }
);
